/**
 * Credito/licenza derivato dall'URL immagine.
 * Wikimedia Commons → link alla pagina File: (autore/licenza sulla pagina file).
 * Asset 6amico (/images, /hero, /api/uploads, /img) → "Archivio 6amico".
 */
export function creditFromSrc(src) {
  const s = String(src || "");
  const m = s.match(/commons\.wikimedia\.org\/(?:wiki\/)?Special:FilePath\/([^?#]+)/i);
  const t = s.match(/wikipedia\/commons\/thumb\/[^/?#]+\/[^/?#]+\/([^/?#]+)/i);
  const file = m ? m[1] : t ? t[1] : "";
  if (file) {
    let name = "";
    try {
      name = decodeURIComponent(file);
    } catch {
      name = file;
    }
    return {
      label: "Wikimedia Commons",
      href: `https://commons.wikimedia.org/wiki/File:${encodeURIComponent(name)}`,
    };
  }
  if (/\/(images|hero|api\/uploads|img)\//i.test(s)) return { label: "Archivio 6amico", href: "" };
  return null;
}
